/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 * EN:英文
 */
 export default {
  userName: { SC:"用户编号", TC: "用戶編號", EN: "User Code"},
  login: { SC:"登录", TC: "登錄", EN: "Sign In"},
  forgotPpassword: { SC: "About", TC: "About", EN: "About"},
  forgotPasswordInfo: {
    SC: "请输入您的登录用户名，系统会将重置密码链接发送到与帐户相关的电子邮件地址。",
    TC: "請輸入您的登錄用戶名，系統會將重置密碼鏈接發送到與帳戶相關的電子郵件地址。",
    EN: "Please enter your login username, the system will send the reset password link to the account related email address."
  },
  resetPassword: { SC: "重置密码", TC: "重置密碼", EN: "Reset Password"},
  send: { SC: "发送成功", TC: "發送成功", EN: "Send successful."},
  userNameIsNoNull: { SC:"用戶编号不能为空", TC: "用戶編號不能為空", EN: "User Code is required." },
}